import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Grid, TextField, Button, Box, InputAdornment, IconButton } from "@mui/material";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import PinDropIcon from "@mui/icons-material/PinDrop";
import { ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import "./Create_device.css";
import apiService from "../../utils/apiservice";
import { Switch, FormControlLabel, Typography } from "@mui/material";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import LockIcon from "@mui/icons-material/Lock";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem
} from "@mui/material";


const CreateDevice = () => {

  const [deviceData, setDeviceData] = useState({
    device_name: "",
    imeiNumber: "",
    latitude: "",
    longitude: "",
    clientId: "",
    userName: "",
    password: "",
    deviceProfile: ""
  });

  const [errors, setErrors] = useState({});
  const [mqttAuthEnabled, setMqttAuthEnabled] = useState(true);
  const [showPassword, setShowPassword] = useState(false);
  const [deviceProfiles, setDeviceProfiles] = useState([]);

  const navigate = useNavigate();
  const API_URL = process.env.REACT_APP_API_DJANGO_URL;

  // ✅ Regex
  const deviceNameRegex = /^[A-Za-z0-9]+( [A-Za-z0-9]+)*$/;
  const imeiRegex = /^[0-9]{15}$/;
  const coordinateRegex = /^-?\d+(\.\d{1,6})?$/;
  const alphaNumericRegex = /^[A-Za-z0-9]+$/;

  // const validateForm = () => {
  //   const tempErrors = {};
  //   const { device_name, imeiNumber, clientId, userName, password } = deviceData;

  //   // ✅ Device Name Validation
  //   if (!device_name) {
  //     tempErrors.device_name = "Device name is required";
  //   } else if (device_name.length < 2 || device_name.length > 20) {
  //     tempErrors.device_name = "Must be 2–20 characters";
  //   } else if (!deviceNameRegex.test(device_name)) {
  //     tempErrors.device_name =
  //       "Only letters & numbers, single spaces between words, no leading/trailing spaces";
  //   }

  //   // ✅ IMEI Validation (optional)
  //   if (imeiNumber && !imeiRegex.test(imeiNumber)) {
  //     tempErrors.imeiNumber = "IMEI must be exactly 15 digits";
  //   }

  //   // ✅ MQTT validation (unchanged)
  //   if (mqttAuthEnabled) {
  //     if (!clientId) tempErrors.clientId = "Client ID required";
  //     if (!userName) tempErrors.userName = "Username required";
  //     if (!password) tempErrors.password = "Password required";
  //   }

  //   setErrors(tempErrors);
  //   return Object.keys(tempErrors).length === 0;
  // };

  const generateRandomString = (length) => {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    return Array.from({ length }, () => chars[Math.floor(Math.random() * chars.length)]).join('');
  };

  useEffect(() => {

    // AUTO MODE
    if (mqttAuthEnabled) {

      const newData = {
        clientId: generateRandomString(12),
        userName: generateRandomString(12),
        password: generateRandomString(15),
      };

      setDeviceData((prev) => ({
        ...prev,
        ...newData
      }));

    }

    // MANUAL MODE
    else {
      setDeviceData((prev) => ({
        ...prev,
        clientId: "",
        userName: "",
        password: "",
      }));
    }

    // clear errors
    setErrors((prev) => ({
      ...prev,
      clientId: "",
      userName: "",
      password: ""
    }));

  }, [mqttAuthEnabled]);

  const validateField = (name, value) => {
    let error = "";

    if (name === "device_name") {
      if (!value) {
        error = "Device name is required";
      } else if (value.length < 2 || value.length > 30) {
        error = "Must be 2–30 characters";
      } else if (!deviceNameRegex.test(value)) {
        error =
          "Only letters & numbers, No extra space";
      }
    }

    if (name === "imeiNumber") {
      if (value && !imeiRegex.test(value)) {
        error = "Allowed only numbers and must be 15 digits ";
      }
    }

    // ✅ Latitude validation
    if (name === "latitude") {
      if (!value) {
        error = "Latitude is required";
      } else if (!coordinateRegex.test(value)) {
        error = "Max 6 digits allowed after decimal";
      } else if (parseFloat(value) < -90 || parseFloat(value) > 90) {
        error = "Latitude must be between -90 and 90";
      }
    }

    // ✅ Longitude validation
    if (name === "longitude") {
      if (!value) {
        error = "Longitude is required";
      } else if (!coordinateRegex.test(value)) {
        error = "Max 6 digits allowed after decimal";
      } else if (parseFloat(value) < -180 || parseFloat(value) > 180) {
        error = "Longitude must be between -180 and 180";
      }
    }

    if (!mqttAuthEnabled) {

      // CLIENT ID
      if (name === "clientId") {
        if (!value) {
          error = "Client ID required";
        } else if (!alphaNumericRegex.test(value)) {
          error = "Only alphanumeric allowed";
        } else if (value.length !== 12) {
          error = "Client ID must be exactly 12 characters";
        }
      }

      // USERNAME
      if (name === "userName") {
        if (!value) {
          error = "Username required";
        } else if (!alphaNumericRegex.test(value)) {
          error = "Only alphanumeric allowed";
        } else if (value.length !== 12) {
          error = "Username must be exactly 12 characters";
        }
      }

      // PASSWORD
      if (name === "password") {
        if (!value) {
          error = "Password required";
        } else if (!alphaNumericRegex.test(value)) {
          error = "Only alphanumeric allowed";
        } else if (value.length !== 15) {
          error = "Password must be exactly 15 characters";
        }
      }
    }

    return error;
  };


  const handleChange = (e) => {
    const { name, value } = e.target;

    let updatedValue = value;

    // ✅ Fix spaces for device name
    if (name === "device_name") {
      updatedValue = value
        .replace(/\s+/g, " ")   // multiple spaces → one
        .replace(/^\s/, "");    // no starting space
    }

    // ✅ Update state
    setDeviceData((prev) => ({
      ...prev,
      [name]: updatedValue
    }));

    // ✅ Real-time validation
    const error = validateField(name, updatedValue);

    setErrors((prev) => ({
      ...prev,
      [name]: error
    }));
  };


  useEffect(() => {
    const fetchDeviceProfiles = async () => {
      try {
        const response = await apiService({
          url: "/api/get_device_profiles/",
          method: "GET",
        });

        const profiles = response?.data?.data;

        if (Array.isArray(profiles) && profiles.length > 0) {
          setDeviceProfiles(profiles);

          // ✅ auto select FIRST profile
          setDeviceData((prev) => ({
            ...prev,
            deviceProfile: profiles[0].id.id,
          }));
        } else {
          setDeviceProfiles([]);
        }

      } catch (error) {
        console.error(error);
        toast.error("Failed to load device profiles");
        setDeviceProfiles([]);
      }
    };

    fetchDeviceProfiles();
  }, []);

  const handleFormSubmit = async (e) => {
    e.preventDefault();

    // ✅ Check if any error exists
    const hasErrors = Object.values(errors).some((err) => err);

    // ✅ Also check required fields manually
    if (
      hasErrors ||
      !deviceData.device_name ||
      (mqttAuthEnabled &&
        (!deviceData.clientId ||
          !deviceData.userName ||
          !deviceData.password))
    ) {
      toast.error("Please fix errors before submitting");
      return;
    }

    try {
      const token = localStorage.getItem("accessToken");

      // const response = await axios({
      //   url: `${API_URL}/api/create_device/`,
      //   method: "POST",
      //   headers: {
      //     Authorization: `Bearer ${token}`,
      //     Accept: "application/json",
      //     "Content-Type": "application/json",
      //   },
      //   data: {
      //     ...deviceData,
      //     label: deviceData.imeiNumber || ""
      //   },
      // });


      const response = await apiService({
        url: "/api/create_device/",
        method: "POST",
        data: { ...deviceData, label: deviceData.imeiNumber || "", deviceProfile: deviceData.deviceProfile }
      });

      console.log("Device created:", response.data);
      toast.success("Device created successfully!");

      setDeviceData({
        device_name: "",
        imeiNumber: "",
        latitude: "",
        longitude: "",
        clientId: "",
        userName: "",
        password: "",
        deviceProfile: ""
      });

    } catch (error) {
      console.error(error);
      toast.error(error.response?.data?.error || "Failed to create device");
    }
  };


  return (
    <Box component="form" className="create-device-form-container" onSubmit={handleFormSubmit}>
      <Grid item xs={12} sm={6}>
        <TextField
          className="create-device-input"
          label="Device Name"
          name="device_name"
          value={deviceData.device_name}
          onChange={handleChange}
          error={!!errors.device_name}
          helperText={errors.device_name}
          required
        />
      </Grid>


      <Grid container spacing={3}>





        <Grid item xs={12} sm={6}>
          <FormControl sx={{ width: 325 }} className="device-profile-select">
            <InputLabel>Device Profile</InputLabel>

            <Select
              name="deviceProfile"
              value={deviceData.deviceProfile}
              onChange={handleChange}
              label="Device Profile"
            >
              {Array.isArray(deviceProfiles) &&
                deviceProfiles.map((profile) => (
                  <MenuItem
                    key={profile.id.id}
                    value={profile.id.id}
                  >
                    {profile.name}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
        </Grid>

        {/* ✅ IMEI FIELD */}
        <Grid item xs={12} sm={6}>
          <TextField
            className="create-device-input"
            label="IMEI Number (Optional)"
            name="imeiNumber"
            value={deviceData.imeiNumber}
            onChange={handleChange}
            error={!!errors.imeiNumber}
            helperText={errors.imeiNumber}
          />
        </Grid>



        <Grid item xs={12} sm={6}>
          <TextField
            className="create-device-input"
            type="number"
            label="Latitude"
            name="latitude"
            value={deviceData.latitude}
            onChange={handleChange}
            error={!!errors.latitude}
            helperText={errors.latitude}
            required
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <LocationOnIcon />
                </InputAdornment>
              )
            }}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <TextField
            className="create-device-input"
            type="number"
            label="Longitude"
            name="longitude"
            value={deviceData.longitude}
            onChange={handleChange}
            error={!!errors.longitude}
            helperText={errors.longitude}
            required
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <PinDropIcon />
                </InputAdornment>
              )
            }}
          />
        </Grid>




        <Grid item xs={12}>
          <Box display="flex" alignItems="center">
            <LockIcon sx={{ color: "black" }} />
            <Typography variant="subtitle1" sx={{ ml: 1, fontWeight: "bold" }}>
              MQTT Auth
            </Typography>

            <FormControlLabel
              control={
                <Switch
                  checked={mqttAuthEnabled}
                  onChange={(e) => setMqttAuthEnabled(e.target.checked)}
                  color="primary"
                />
              }
              label={mqttAuthEnabled ? "Auto" : "Manual"}
              sx={{ marginLeft: 1 }}
            />
          </Box>
        </Grid>

        <Grid item xs={12}>
          <Box className="mqtt-row">

            <TextField
              className="mqtt-input"
              label="Client ID"
              name="clientId"
              value={deviceData.clientId}
              onChange={handleChange}
              error={!!errors.clientId}
              helperText={errors.clientId}
              disabled={mqttAuthEnabled}
            />

            <TextField
              className="mqtt-input"
              label="Username"
              name="userName"
              value={deviceData.userName}
              onChange={handleChange}
              error={!!errors.userName}
              helperText={errors.userName}
              disabled={mqttAuthEnabled}
            />

            <TextField
              className="mqtt-input"
              label="Password"
              name="password"
              type={showPassword ? "text" : "password"}
              value={deviceData.password}
              onChange={handleChange}
              error={!!errors.password}
              helperText={errors.password}
              disabled={mqttAuthEnabled}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => setShowPassword(!showPassword)}
                      edge="end"
                    >
                      {showPassword ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                  </InputAdornment>
                )
              }}
            />

          </Box>
        </Grid>

      </Grid>

      <Box className="submit-btn-wrapper">

        <Button
          type="button"
          variant="outlined"
          className="submit-btn cancel-btn"
          onClick={() => {
            setDeviceData({
              device_name: "",
              imeiNumber: "",
              latitude: "",
              longitude: ""
            });
            setErrors({});
            navigate("/dashboard");
          }}
        >
          Cancel
        </Button>

        <Button type="submit" variant="contained" className="submit-btn">
          Create Device
        </Button>

      </Box>

      <ToastContainer autoClose={3000} />

    </Box>
  );
};

export default CreateDevice;